// Copyright (c) StrangeBee 2024

export const typeGuard = <T>(value: any, values: readonly T[]): value is T => values.includes(value);
